/* global google */
import { updateReceiveAddress, validateReceiveAddress } from '@/api/logisticsOrders';
import { Loader } from '@googlemaps/js-api-loader';
import { googleMapKeyEncryptedApi } from '@/api/newExpressAPI';
import { decrypt } from '@/utils/RSA_util_new';
import CurrentAddress from './CurrentAddress.vue';

export default {
  name: 'EditRecipientInformation',
  components: { CurrentAddress },
  props: {
    receviceRuleForm: {
      type: Object,
      default: () => ({
        receiveTax: '',
        receiveMobile: '',
        receiveName: '',
        receiveZipcode: '',
        receiveStreet: '',
        receiveHouseNumber: '',
        receiveState: '',
        receiveCity: '',
        receiveArea: '',
        receiveComplement: '',
        receiveAddress: ''
      })
    },
    selectionList: {
      type: Array,
      default: () => []
    },
    oldZipCode: {
      type: String,
      default: null
    },
    changeType: {
      type: Number,
      default: 1
    }
  },
  data() {
    return {
      showLat: '',
      showLng: '',
      fixAddress: false,
      confirmDialog: false,
      localForm: {},
      cityList: [],
      map: null,
      geocoder: null,
      searchText: '',
      marker: null,
      loading: false,
      mapClickListener: null, // 保存地图监听器引用，用于清理
      addressSupplement: ''
    };
  },
  watch: {
    // 🔥 监听本地副本变化，通知父组件
    localForm: {
      handler(newVal) {
        this.$emit('update:receviceRuleForm', { ...newVal });
      },
      deep: true
    }
  },
  async mounted() {
    try {
      // this.searchText = [
      //   this.localForm.receiveStreet,
      //   this.localForm.receiveArea,
      //   this.localForm.receiveCity,
      //   this.localForm.receiveState,
      //   this.formatBrazilZip(this.localForm.receiveZipcode),
      //   this.receviceRuleForm.receiveAddress
      // ]
      //   .filter(Boolean)
      //   .join(', ');
      await this.initMapLoader();
      this.bindMapClickEvent();
    } catch (error) {
      console.error('地图初始化失败:', error);
    }
  },
  beforeDestroy() {
    // 清理地图监听器，防止内存泄漏
    if (this.mapClickListener && this.map) {
      google.maps.event.removeListener(this.mapClickListener);
    }
    if (this.marker) {
      this.marker.setMap(null);
    }
    if (this.map) {
      this.map = null;
    }
  },
  methods: {
    async validateAddress() {
      const returnStr = await this.doSearch(1);
      if (returnStr === 0) {
        return;
      }
      const data = {
        waybillNumbers: [],
        receiveZipcode: this.localForm.receiveZipcode
      };
      this.selectionList.forEach((item) => {
        data.waybillNumbers.push(item.waybillNumber);
      });
      const res = await validateReceiveAddress(data);
      if (res.data && res.data.valid === true) {
        this.confirmDialog = true;
      } else {
        if (res.data.message) {
          this.$message.error(res.data.message);
        }
      }
    },
    /**
     * 提交修改收件人信息
     */
    async confirmEdit() {
      try {
        const data = {
          ...this.localForm,
          updateZipCode: 0
        };
        this.confirmDialog = false;
        const { orderIds, waybillNumbers } = this.buildOrderData();
        data.receiveZipcode = data.receiveZipcode.replace(/-/g, '');
        if (this.addressSupplement) {
          data.receiveComplement = this.addressSupplement.trim();
        }
        data.orderIds = orderIds;
        data.waybillNumbers = waybillNumbers;
        data.needUpdateReceiver = this.changeType !== 1;
        data.updateZipCode = this.shouldUpdateZipCode(orderIds);
        const res = await updateReceiveAddress(data);
        if (res.code === 200) {
          this.fixAddress = false;
          this.$emit('updateTable', res.data, true);
        }
      } catch (error) {
        console.error('更新收件人信息失败:', error);
      }
    },
    closeForm() {
      this.fixAddress = false;
    },
    async showFixAddress() {
      this.fixAddress = true;
      try {
        this.addressSupplement = '';
        this.searchText = '';
        this.localForm = {};
        // this.$nextTick(() => {
        //   this.searchText = [
        //     this.localForm.receiveStreet,
        //     this.localForm.receiveArea,
        //     this.localForm.receiveCity,
        //     this.localForm.receiveState,
        //     this.formatBrazilZip(this.localForm.receiveZipcode),
        //     this.receviceRuleForm.receiveAddress
        //   ]
        //     .filter(Boolean)
        //     .join(', ');
        // });
        await this.initMapLoader();
        this.bindMapClickEvent();
      } catch (error) {
        console.error('地图初始化失败:', error);
      }
    },
    /**
     * 🎯 【核心方法】初始化地图
     */
    async initMapLoader() {
      try {
        const res = await googleMapKeyEncryptedApi();
        const realApiKey = res.data;

        const loader = new Loader({
          apiKey: decrypt(realApiKey),
          version: 'weekly',
          libraries: ['places'],
          language: 'pt-BR',
          region: 'BR'
        });

        const { Map } = await loader.importLibrary('maps');

        this.geocoder = new google.maps.Geocoder();

        this.map = new Map(document.getElementById('map'), {
          center: { lat: -23.5682, lng: -46.5682 },
          zoom: 15,
          zoomControl: true,
          mapTypeControl: true,
          streetViewControl: true,
          fullscreenControl: true
        });
      } catch (error) {
        console.error('地图初始化错误:', error);
        throw error;
      }
    },

    /**
     * 🎯 【核心方法】绑定地图点击事件
     */
    bindMapClickEvent() {
      if (!this.map) return;

      this.mapClickListener = this.map.addListener('click', (mapsMouseEvent) => {
        const lat = mapsMouseEvent.latLng.lat();
        const lng = mapsMouseEvent.latLng.lng();
        console.log('📍 地图点击位置：', lat, lng);
        this.showLat = lat;
        this.showLng = lng;
        this.placeMarker(lat, lng);
        this.fetchAddressFromLatLng(lat, lng);
      });
    },

    /**
     * 🎯 【核心方法】放置标记
     */
    placeMarker(lat, lng) {
      if (this.marker) {
        this.marker.setMap(null);
      }

      this.marker = new google.maps.Marker({
        position: { lat, lng },
        map: this.map,
        title: '选中位置',
        animation: google.maps.Animation.DROP
      });
    },

    /**
     * 🎯 【核心方法】根据经纬度获取完整地址
     */
    fetchAddressFromLatLng(lat, lng) {
      if (!this.geocoder) {
        this.$message.error(this.$t('scripting.mapServiceNotInitialized'));
        return;
      }
      this.geocoder.geocode(
        {
          location: { lat, lng },
          language: 'pt-BR',
          region: 'BR'
        },
        (results, status) => {
          console.log('📊 逆地理编码状态：', status);
          if (status === 'OK' && results && results.length > 0) {
            this.fillAddressFromResult(results);
          } else if (status === 'ZERO_RESULTS') {
            this.$message.warning('该位置未找到地址信息，请点击建筑物或道路附近');
          } else if (status === 'OVER_QUERY_LIMIT') {
            this.$message.error('查询次数超限，请稍后再试');
          } else {
            this.$message.error('获取地址信息失败：' + status);
          }
        }
      );
    },

    /**
     * 🎯 【核心方法】从结果中提取并回填地址（修正版）
     */
    fillAddressFromResult(results) {
      // 改进：优先选择街道地址类型或包含邮编的结果
      let bestResult = results[0];

      // 先查找精确的街道地址
      for (const result of results) {
        if (result.types && result.types.includes('street_address')) {
          bestResult = result;
          break;
        }
      }

      // 如果没有街道地址，再找包含邮编的
      if (!bestResult.types || !bestResult.types.includes('street_address')) {
        for (const result of results) {
          const hasPostalCode = result.address_components.some((comp) =>
            comp.types.includes('postal_code')
          );
          if (hasPostalCode) {
            bestResult = result;
            break;
          }
        }
      }
      this.parseAddressComponents(bestResult);
    },

    /**
     * 🎯 【核心方法】解析地址组件并更新本地表单（修正巴西邮编问题）
     */
    parseAddressComponents(result) {
      const components = result.address_components;

      const addressData = {
        receiveZipcode: '',
        receiveState: '',
        receiveCity: '',
        receiveArea: '',
        receiveStreet: '',
        receiveHouseNumber: '',
        receiveComplement: '',
        receiveAddress: result.formatted_address
      };

      components.forEach((component) => {
        const types = component.types;
        const longName = component.long_name;
        const shortName = component.short_name;

        // 邮编 - 修正：优先使用 short_name，如果没有则使用 long_name
        if (types.includes('postal_code')) {
          const postalCodeValue = shortName || longName;
          // 保留巴西邮编格式，只移除字母，保留数字和连字符
          addressData.receiveZipcode = postalCodeValue.replace(/[A-Za-z]/g, '');
          console.log('  ✅ 邮编:', addressData.receiveZipcode);
        } else if (types.includes('administrative_area_level_1')) {
          addressData.receiveState = shortName || longName;
          console.log('  ✅ 州:', addressData.receiveState);
        } else if (types.includes('administrative_area_level_2')) {
          addressData.receiveCity = longName;
          console.log('  ✅ 城市:', addressData.receiveCity);
        } else if (types.includes('locality') && !addressData.receiveCity) {
          addressData.receiveCity = longName;
          console.log('  ✅ 城市(locality):', addressData.receiveCity);
        } else if (types.includes('sublocality_level_1')) {
          addressData.receiveArea = longName;
          console.log('  ✅ 区:', addressData.receiveArea);
        } else if (
          (types.includes('sublocality') || types.includes('neighborhood')) &&
          !addressData.receiveArea
        ) {
          addressData.receiveArea = longName;
          console.log('  ✅ 区(sub/neighborhood):', addressData.receiveArea);
        } else if (types.includes('route')) {
          addressData.receiveStreet = longName;
          console.log('  ✅ 街道:', addressData.receiveStreet);
        } else if (types.includes('street_number')) {
          addressData.receiveHouseNumber = longName;
          console.log('  ✅ 门牌号:', addressData.receiveHouseNumber);
        } else if (types.includes('subpremise')) {
          // addressData.receiveComplement = longName;
          console.log('  ✅ 补充:', addressData.receiveComplement);
        }
      });
      // 巴西地址特殊处理：如果没有找到区，尝试从其他字段补充
      if (!addressData.receiveArea) {
        const neighborhoodComp = components.find(
          (comp) =>
            comp.types.includes('neighborhood') ||
            comp.types.includes('sublocality') ||
            comp.types.includes('sublocality_level_2')
        );
        if (neighborhoodComp) {
          addressData.receiveArea = neighborhoodComp.long_name;
          console.log('  ⚠️ 补充区域:', addressData.receiveArea);
        }
      }
      // ====================== 【核心修正：巴西邮编自动补全】 ======================
      if (addressData.receiveZipcode) {
        // 先清理所有非数字字符
        const zip = addressData.receiveZipcode.replace(/\D/g, '');

        // 情况1：5位 → 补 -000
        if (zip.length === 5) {
          addressData.receiveZipcode = zip + '-000';
        } else if (zip.length === 8) {
          addressData.receiveZipcode = zip.replace(/(\d{5})(\d{3})/, '$1-$2');
        }
        console.log('  📮 最终格式化邮编:', addressData.receiveZipcode);
      }
      // 🔥 更新本地表单数据
      this.localForm = {
        ...this.localForm,
        ...addressData
      };
      // 🔥 打印回填结果
      console.log('📋 ===== 表单回填结果 =====');
      this.$message.success(this.$t('scripting.addressAutoFilled'));
    },
    /**
     * 执行地址搜索（修正版）
     */
    async doSearch(val) {
      if (!this.searchText || !this.searchText.trim()) {
        // 判断对象是否拥有自身属性
        const hasProperties = Object.keys(this.localForm).length > 0;
        console.log(hasProperties, 'hasProperties');
        if (val && hasProperties) {
          return 1;
        } else {
          this.$message.warning(this.$t('scripting.enterSearchAddress'));
          return 0;
        }
      }
      if (!this.geocoder) {
        this.$message.error(this.$t('scripting.mapServiceNotReady'));
        return 0;
      }
      try {
        this.loading = true;
        this.geocoder.geocode(
          {
            address: this.searchText,
            componentRestrictions: { country: 'BR' },
            language: 'pt-BR'
          },
          (results, status) => {
            if (status === 'OK' && results.length > 0) {
              const location = results[0].geometry.location;
              const lat = location.lat();
              const lng = location.lng();

              this.map.setCenter({ lat, lng });
              this.map.setZoom(17);
              this.placeMarker(lat, lng);
              // 修正：传入完整 results 而不是单个结果
              this.fillAddressFromResult(results);
            } else {
              this.$message.error(this.$t('scripting.noMatchingAddress'));
            }
          }
        );
      } catch (error) {
        console.error('地址搜索失败:', error);
        this.$message.error(this.$t('scripting.addressSearchFailed'));
      } finally {
        this.loading = false;
      }
    },
    /**
     * 构建订单数据
     */
    buildOrderData() {
      const orderIds = [];
      const waybillNumberList = [];

      this.selectionList.forEach((item) => {
        const orderId = item.orderId || item.id;
        if (orderId) {
          orderIds.push(orderId);
        }

        if (this.changeType === 1) {
          if (item.waybillNumber) {
            waybillNumberList.push(item.waybillNumber);
          }
        } else {
          if (item.waybillList && Array.isArray(item.waybillList)) {
            item.waybillList.forEach((list) => {
              if (!waybillNumberList.includes(list)) {
                waybillNumberList.push(list);
              }
            });
          }
        }
      });

      return { orderIds, waybillNumbers: waybillNumberList };
    },

    /**
     * 判断是否需要更新邮编
     */
    shouldUpdateZipCode(orderIds) {
      if (orderIds.length > 1) {
        return 1;
      }
      return this.oldZipCode !== this.localForm.receiveZipcode ? 1 : 0;
    }
  }
};
